import React from "react";
import { withRouter } from "react-router-dom";
import CONSTANT from "./../../../constant";
import Loader from "./../../../component/common/Loader";
import AparEmployeeHeader, { normalizeManagers, mergeManagerData } from "./../../../component/common/AparEmployeeHeader";
import { getReportingAssessment, saveReportingFinalGrade, updateReportingFinalGrade } from "./../../../actions/AppraisalCycleAction";

const INTEGRITY_OPTIONS = [
  { value: 'beyond_doubt', label: 'Beyond doubt' },
  { value: 'doubtful', label: 'Integrity is doubtful (secret note attached)' },
  { value: 'nothing_adverse', label: 'Nothing adverse received' },
];

class aparReportingManagerForm4 extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      showLoader: false,
      employeeData: null,
      kpiReportId: null,
      reportingAssessmentId: null,
      hasExistingFinalGrade: false,
      isSubmitted: false,
      integrity: '',
      penPicture: '',
      overallGrade: '',
      kpiTotal: '',
      attrTotal: '',
      secretNoteFile: null as File | null,
      existingSecretNoteFile: '',
      existingSecretNoteOriginalName: '',
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    document.title = "Integrity & Overall Grade - " + CONSTANT.organisation.name;

    const locationState = this.props.location?.state || {};
    const { reportingAssessmentId, kpiReportId, kpiTotal, overallGrading, employeeCode, employeeName, employeeNumber, effectiveFrom, effectiveTo } = locationState;
    const employeeData = { employeeCode, employeeName, employeeNumber, effectiveFrom, effectiveTo, ...normalizeManagers(locationState) };

    const kpiTotalNum = parseFloat(kpiTotal);
    const attrTotalNum = parseFloat(overallGrading);
    const hasPreview = Number.isFinite(kpiTotalNum) && Number.isFinite(attrTotalNum);

    this.setState({
      employeeData,
      kpiReportId,
      reportingAssessmentId,
      kpiTotal: Number.isFinite(kpiTotalNum) ? String(kpiTotalNum) : '',
      attrTotal: Number.isFinite(attrTotalNum) ? String(attrTotalNum) : '',
      overallGrade: hasPreview ? (kpiTotalNum + attrTotalNum).toFixed(2) : '',
    });

    if (kpiReportId) {
      this.loadExistingData(kpiReportId);
    }
  }

  loadExistingData = (kpiReportId: any) => {
    this.setState({ showLoader: true });
    getReportingAssessment({ kpiReportId }).then((res: any) => {
      const data = res?.result || res;
      if (data) {
        this.setState((prev: any) => ({
          integrity: data.integrity || '',
          penPicture: data.pen_picture || '',
          overallGrade: data.overall_grade ? String(data.overall_grade) : this.state.overallGrade,
          kpiTotal: data.kpi_total ? String(data.kpi_total) : this.state.kpiTotal,
          attrTotal: data.attr_total ? String(data.attr_total) : this.state.attrTotal,
          existingSecretNoteFile: data.secret_note_file || '',
          existingSecretNoteOriginalName: data.secret_note_original_name || '',
          hasExistingFinalGrade: !!(data.integrity || data.pen_picture),
          isSubmitted: !!data.is_submitted,
          employeeData: { ...prev.employeeData, ...mergeManagerData(prev.employeeData, data) },
        }));
        if (data.id) {
          this.setState({ reportingAssessmentId: data.id });
        }
      }
      this.setState({ showLoader: false });
    }).catch(() => {
      this.setState({ showLoader: false });
    });
  };

  validateForm = () => {
    const { integrity, penPicture, secretNoteFile, existingSecretNoteFile } = this.state;
    if (!integrity) {
      alert("Please select an integrity option.");
      return false;
    }
    if (integrity === 'doubtful' && !secretNoteFile && !existingSecretNoteFile) {
      alert("Please upload the secret note file for 'Integrity is doubtful'.");
      return false;
    }
    if (!penPicture.trim()) {
      alert("Please enter the pen picture.");
      return false;
    }
    return true;
  };

  callFinalGradeApi = (isSubmit: boolean, callback: (res: any) => void) => {
    const { kpiReportId, hasExistingFinalGrade, integrity, penPicture, secretNoteFile } = this.state;

    if (!kpiReportId) {
      alert("KPI Report ID not found. Please go back and try again.");
      return;
    }

    this.setState({ showLoader: true });

    const payload = new FormData();
    payload.append('kpiReportId', String(kpiReportId));
    payload.append('integrity', integrity);
    payload.append('penPicture', penPicture);
    payload.append('isSubmit', isSubmit ? 'true' : 'false');
    if (integrity === 'doubtful' && secretNoteFile) {
      payload.append('secretNote', secretNoteFile);
    }

    const apiCall = hasExistingFinalGrade
      ? updateReportingFinalGrade(payload)
      : saveReportingFinalGrade(payload);

    apiCall.then((res: any) => {
      this.setState({ showLoader: false, hasExistingFinalGrade: true });
      callback(res);
    }).catch(() => {
      this.setState({ showLoader: false });
    });
  };

  handleSaveDraft = () => {
    this.callFinalGradeApi(false, () => {
      alert('Saved as draft.');
    });
  };

  onSubmit = (e: any) => {
    e.preventDefault();
    if (!this.validateForm()) return;

    if (!window.confirm('Are you sure you want to submit the appraisal? This action cannot be undone.')) return;

    this.callFinalGradeApi(true, (res: any) => {
      const result = res?.result || res || {};
      this.setState({
        overallGrade: result.overallGrade ? String(result.overallGrade) : this.state.overallGrade,
        kpiTotal: result.kpiTotal ? String(result.kpiTotal) : this.state.kpiTotal,
        attrTotal: result.attrTotal ? String(result.attrTotal) : this.state.attrTotal,
        isSubmitted: true,
      });
      alert("Appraisal submitted successfully!");
      this.props.history.push(CONSTANT.component.reportingManagerReport.url);
    });
  };

  render() {
    const { showLoader, employeeData, integrity, penPicture, overallGrade, kpiTotal, attrTotal, isSubmitted, secretNoteFile, existingSecretNoteFile, existingSecretNoteOriginalName, kpiReportId } = this.state;

    return (
      <div className="container mx-auto px-4 py-3">
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-body">

                <div className="row mb-3">
                  <div className="col-md-8">
                    <h1 className="page-title">Reporting Authority - Integrity & Overall Grade</h1>
                  </div>
                  <div className="col-md-4 text-right">
                    <button type="button" className="btn btn-sm cancel-button" onClick={() => this.props.history.goBack()}>
                      <i className="fa fa-arrow-left mr-2" />Back
                    </button>
                  </div>
                </div>
                <AparEmployeeHeader {...employeeData} detailViewerRole="reporting" kpiReportId={this.state.kpiReportId} />

                {showLoader && <Loader />}

                {isSubmitted && (
                  <div className="alert alert-success mt-2">
                    <i className="fa fa-check-circle mr-1" /> This appraisal has been submitted and is now view-only.
                  </div>
                )}

                {!showLoader && (
                  <div>
                    {/* Section 8 - Integrity */}
                    <h2 className="fs-5 fw-bold border-bottom pb-2 mb-4">
                      Integrity
                    </h2>
                    <p className="text-muted small mb-3">
                      <em>Please comment on the integrity of the officer reported upon by choosing any one of the following options:</em>
                    </p>

                    <div className="table-responsive mb-4">
                      <table className="table table-bordered table-sm align-middle">
                        <tbody>
                          {INTEGRITY_OPTIONS.map((option) => (
                            <tr key={option.value}>
                              <td style={{ width: '10%' }}>
                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    type="radio"
                                    name="integrity"
                                    id={`integrity-${option.value}`}
                                    value={option.value}
                                    checked={integrity === option.value}
                                    onChange={(e) => this.setState({ integrity: e.target.value })}
                                    disabled={isSubmitted}
                                  />
                                </div>
                              </td>
                              <td>
                                <label htmlFor={`integrity-${option.value}`} className="mb-0" style={{ cursor: 'pointer' }}>
                                  {option.label}
                                </label>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>

                    {/* Secret Note Upload — shown only when integrity is doubtful */}
                    {integrity === 'doubtful' && (
                      <div className="alert alert-warning mb-4 p-3">
                        <p className="fw-bold mb-2">
                          <i className="fa fa-lock mr-2" />
                          Secret Note Required
                        </p>
                        <p className="small text-muted mb-2">
                          Please attach the secret note (PDF, DOC, DOCX, or image). 
                        </p>
                        {!isSubmitted && (
                          <input
                            type="file"
                            className="form-control"
                            accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                            onChange={(e) => {
                              const file = e.target.files?.[0] || null;
                              this.setState({ secretNoteFile: file });
                            }}
                          />
                        )}
                        {secretNoteFile && (
                          <p className="small text-success mt-1 mb-0">
                            <i className="fa fa-check-circle mr-1" />
                            Selected: {secretNoteFile.name}
                          </p>
                        )}
                        {!secretNoteFile && existingSecretNoteFile && (
                          <p className="small text-info mt-1 mb-0">
                            <i className="fa fa-paperclip mr-1" />
                             Uploaded File:{' '}
                            <a
                              href={`${process.env.REACT_APP_BASE_URL}secret-note/${kpiReportId}/${existingSecretNoteFile}`}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {existingSecretNoteOriginalName || existingSecretNoteFile}
                            </a>
                            {!isSubmitted && ' (upload a new file to replace it)'}
                          </p>
                        )}
                      </div>
                    )}

                    {/* Section 9 - Pen Picture */}
                    <h2 className="fs-5 fw-bold border-bottom pb-2 mb-4">
                      Pen Picture by Reporting Officer
                    </h2>
                    <p className="text-muted small mb-3">
                      <em>Please comment (in about 100 words) on the overall qualities of the officer including areas of strengths and those which need improvements. The pen picture should be consistent with the overall grade furnished in Item no. 10.</em>
                    </p>
                    <textarea
                      className="form-control mb-4"
                      rows={5}
                      value={penPicture}
                      onChange={(e) => this.setState({ penPicture: e.target.value })}
                      placeholder="Enter pen picture..."
                      required
                      disabled={isSubmitted}
                    />

                    {/* Section 10 - Overall Grade (read-only, auto-computed) */}
                    <h2 className="fs-5 fw-bold border-bottom pb-2 mb-4">
                      Overall Grade
                    </h2>
                    <p className="text-muted small mb-3">
                      <em>Overall grade (on a scale of 0-100) is auto-calculated from Item 6 (KPI grades) + Item 7 (Personal Attributes / 4).</em>
                    </p>
                    <div className="mb-4">
                      {overallGrade ? (
                        <div>
                          <div className="d-flex align-items-center gap-3 mb-2">
                            <span className="fw-bold fs-4">{parseFloat(overallGrade).toFixed(2)}</span>
                            <span className="text-muted">/ 100</span>
                            {!isSubmitted && (
                              <span className="small text-info fst-italic">(Preview — finalized on submit)</span>
                            )}
                          </div>
                          {(kpiTotal || attrTotal) && (
                            <div className="small text-muted">
                              {kpiTotal && <span className="me-3">KPI Total: {parseFloat(kpiTotal).toFixed(2)}</span>}
                              {attrTotal && <span>Attributes Total: {parseFloat(attrTotal).toFixed(2)}</span>}
                            </div>
                          )}
                        </div>
                      ) : (
                        <p className="text-muted fst-italic">Overall grade will be auto-computed upon submission.</p>
                      )}
                    </div>

                    {/* Submit */}
                    <div className="d-flex justify-content-end gap-2 mt-3">
                      <button type="button" className="btn btn-outline-secondary" onClick={() => this.props.history.goBack()}>
                        Back
                      </button>
                      {!isSubmitted && (
                        <button type="button" className="btn btn-secondary" onClick={this.handleSaveDraft} disabled={showLoader}>
                          {showLoader ? "Saving..." : "Save Draft"}
                        </button>
                      )}
                      {!isSubmitted && (
                        <button type="button" className="btn btn-primary" onClick={this.onSubmit} disabled={showLoader}>
                          <i className="fa fa-paper-plane mr-1" />{showLoader ? "Submitting..." : "Submit Appraisal"}
                        </button>
                      )}
                    </div>
                  </div>
                )}

              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(aparReportingManagerForm4);
